/* angular:styles/component:css;01f3bacd7b9e345ed1d15c7a54d67bbefacc32c42c5a08f1db0c5b31f7515a4e;C:\Projects\WebGalis-FE\src\app\components\containers\sem-server-unavailable\sem-server-unavailable.component.ts */
.server-unavailable {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  padding: 40px 20px;
  text-align: center;
  font-family:
    "Segoe UI",
    Tahoma,
    Geneva,
    Verdana,
    sans-serif;
  color: #333;
}
.icon {
  font-size: 64px;
  margin-bottom: 20px;
  opacity: 0.6;
}
h2 {
  margin: 0 0 12px;
  font-size: 24px;
  font-weight: 600;
  color: #c0392b;
}
p {
  margin: 0 0 8px;
  font-size: 15px;
  color: #666;
  max-width: 500px;
  line-height: 1.5;
}
.retry-btn {
  margin-top: 24px;
  padding: 10px 28px;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  background: #2980b9;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s;
}
.retry-btn:hover {
  background: #1f6da0;
}
/*# sourceMappingURL=sem-server-unavailable.component.css.map */
